import { StepEnum } from '../../../../../components-library/checkout/CheckoutSteps';

export default {
  steps: {
    [StepEnum.OrderConfirmation]: 'Verificare comandă',
    [StepEnum.OrderPayment]: 'Plată',
  },
};
